var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.267,
    height: 22.108,
    viewBox: "0 0 25.267 22.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-trophy",
    "data-name": "Icon metro-trophy",
    d: "M23.1,7.014V3.856H7.308V7.014H2.571v3.158a4.741,4.741,0,0,0,6.159,4.52,7.9,7.9,0,0,0,4.895,3.217v4.9H12.046a3.158,3.158,0,0,0-3.158,3.158H21.521a3.158,3.158,0,0,0-3.158-3.158H16.783v-4.9a7.9,7.9,0,0,0,4.895-3.217,4.741,4.741,0,0,0,6.159-4.52V7.014ZM7.308,13.035a2.865,2.865,0,0,1-2.862-2.862V8.594H7.308v1.579a7.877,7.877,0,0,0,.517,2.815,2.866,2.866,0,0,1-.517.048Zm18.654-2.862a2.859,2.859,0,0,1-3.379,2.815,7.877,7.877,0,0,0,.517-2.815V8.594h2.862v1.579Z",
    transform: "translate(-2.571 -3.856)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.58b1727fc51b31b2a9684b608269e510.svg";
export { ForwardRef as ReactComponent };